import { version as ReactVersion } from 'react';

import { App } from './App';
import { getConfiguration } from '~/utils';

export const render = async (rootElement: HTMLElement, isECatalogue: boolean) => {
  const configuration = getConfiguration(rootElement);

  if (ReactVersion.startsWith('18')) {
    const { createRoot } = await import('react-dom/client');
    createRoot(rootElement).render(
      <App
        configuration={configuration}
        isECatalogue={isECatalogue}
      />,
    );
  } else {
    if (__DEV__) {
      // eslint-disable-next-line no-console -- show the info in console
      console.error('react-dom/client cannot be imported using legacy render');
    }
    const { render: reactDomRender } = await import('react-dom');
    reactDomRender(
      <App
        configuration={configuration}
        isECatalogue={isECatalogue}
      />,
      rootElement,
    );
  }
};
